<template>
  <div class="row mt-3">
    <div class="col-md-6 col-12" v-for="(item, key) in series" :key="item.title_no">
      <b-card no-body class="overflow-hidden" border-variant="dark">
        <b-row no-gutters>
          <b-col>
            <b-card-body :title="`${item.title_name} ${item.title_no}`" :sub-title="item.lecr_name">
              <b-button
                squared
                variant="outline-primary"
                target="_blank"
                :to="{ name: 'series', params: { series_no: item.title_no } }"
              >{{ $t('series.list.button.introduction.label') }}</b-button>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)

export default {
  i18n,
  name: 'series-card-list',
  props: {
    series: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // 
  },
  components: {
    // 
  }
}
</script>